import allTranslations from "./translations.json";

/**
 * @typedef {Object} Translations
 * @property {string} no_container_element_provided
 * @property {string} no_container_selector_found
 * @property {string} web_speech_api_not_supported
 * @property {string} unsupported_option_ignored
 * @property {string} listen_to_this_page
 */

/**
 * Get merged translations for a language (fallback to English), always returning all keys in base.
 * @param {string} [lang="en"]
 * @returns {Translations}
 */
export function getTranslations(lang = "en") {
    const selected = allTranslations[lang] || allTranslations.en;

    return /** @type {Translations} */ ({
        ...allTranslations.base,
        ...selected,
    });
}
